<template>
	<div class="my_body">
		<div class="bg"></div>
		<div class="my-page-first">
			<div class="my-update">
				<div class="s-body" v-show="show_upd">
					<div class="s-name">{{list_upd.s_name}}</div>
					<div class="s-desc" v-html="list_upd.s_desc"></div>
					<div class="s-date">{{list_upd.s_date}}<a class="blink s-more"
							href="http://haojun.work/home/?pagekey=workupdate&id=4" target="_blank">更多详情</a></div>
				</div>

			</div>
			<div v-loading="fullscreenLoading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" class="my-login">
				<div>
					<h1>领科软件服务V1.0</h1>
				</div>
				<div>
					<div class="dl">
						<!-- <img
		          src="@/assets/image/sj01.png"
		          alt=""
		        > -->
						<input type="text" v-model="userno" placeholder="请输入账户或手机号" class="shuru">
					</div>
				</div>
				<div>
					<div class="dl">
						<!-- <img
		          src="@/assets/image/mima03.png"
		          alt=""
		        > -->
						<input type="password" v-model="pwd" placeholder="请输入登录密码" @keyup.enter="mylogin" class="shuru">

					</div>
				</div>
				<div>
					<input type="button" value="登录" @click="mylogin">
				</div>
				<div style="margin-top: 20px;"><a href="https://beian.miit.gov.cn/"
						style="color: white;font-size: 12px;" target="_blank">备案号:{{record}}</a></div>
			</div>

		</div>
	</div>
</template>

<script>
	import login from '@/store/store';

	import {
		api_get
	} from '@/utils/http_other.js';

	import {
		mapActions
	} from 'vuex';
	
	import api from '@/utils/type.js'
	import {
		Sel_page_and_length,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		GoUrl,
		isPC
	} from '@/utils/method.js';

	import {
		base_encode,
		base_decode
	} from '@/utils/base64.js'

	import mystore from '@/utils/localstore.js';
	// import '@/utils/tx_1.js';

	export default {
		data() {
			return {
				fullscreenLoading: false,
				userno: "",
				pwd: '',

				show_upd: false,
				list_upd: {},

				record: ''
			};
		},
		created: function() {
			// this.mylogin();
			isPC(this);
			this.init_update();
			this.init_login();
		},
		methods: {
			...mapActions("login", ['login_up']),
			mylogin: async function() {
				// console.log('userno=' + this.userno + ' pwd=' + this.pwd);
				if (this.userno == "" || this.pwd == "") {
					let t = (localStorage.getItem('userdata'));
					if (t == null || t === undefined || t == '') {
						this.$message({
							message: '登录信息已经过期,请重新登录!',
							type: 'error'
						});
						return;
					}
					t = JSON.parse(t);
					// console.log(t);
					this.userno = t[0].uno;
					this.pwd = base_decode(localStorage.getItem('pwd'));
				}

				// console.log('userno=' + this.userno + ' pwd=' + this.pwd);
				if (this.userno != "" && this.pwd != "") {
					this.fullscreenLoading = true;

					// 方法一调用
					var res = await this.login_up({
						"userno": this.userno,
						"pwd": this.pwd
					}); //通过dispatch调用actions里的方法
					//       console.log(res);
					// console.log(res.data[0]);
					console.log('登录反馈',res);

					if (res.data[0].status == '1') {
						GoUrl(this, 'main');
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}


					// 方法二调用 模块模式
					// var data = await this.login_up({
					//   "userno": this.userno,
					//   "pwd": this.pwd
					// }); //通过dispatch调用actions里的方法

					// if (data.status == 1) {
					//   this.$message({
					//     message: data.msg,
					//     type: 'success'
					//   });

					//   mystore.setTempParm('userno', data.uno);
					//   mystore.setTempParm('rid', data.rid);
					//   mystore.setTempParm('phone', data.phone);
					//   mystore.setTempParm('email', data.email);

					//   GoUrl(this, 'main');
					// } else {

					//   this.userno = '';
					//   this.pwd = '';
					//   this.$message({
					//     message: '登录失败,账户或者密码错误!',
					//     type: 'error'
					//   });
					// }


					this.fullscreenLoading = false;


				} else {
					// MessageBox("提示", "操作失败,账户 和 密码都 不能为空 ");
					this.$message.error('账户和密码都不能为空!');
				}
			},
			init_update: async function() {

				let r = (Math.random() + '').substring(0, 8);
				let load_json = Sel_page_and_length('exp_info_update_m', 1, 99, 'wlgl_new', '', '', '', '', r);

				let d = await api_get('/Data_All', 'rhkj', load_json);
				d = JSON.parse(d);
				// console.log('更新反馈',d);
				// 加载更新内容的
				if (d.length > 0) {
					if (d[0][0].flag == '1' && d[0][0].all_count > 0) {
						// console.log(d[0][0]);
						let o = {};

						o.s_name = d[1][0].s_name;
						o.s_date = d[1][0].s_date;
						let temp_str = d[1][0].s_desc;

						if (typeof(temp_str) === 'string') {
							while (temp_str.indexOf('\\r\\n') > 0) {
								// console.log('解析换行1');
								temp_str = temp_str.replace("\\r\\n", "<br>");
							}
							while (temp_str.indexOf('\n') > 0) {
								// console.log('解析换行2');
								temp_str = temp_str.replace("\n", "<br>");
							}
						}
						o.s_desc = temp_str;
						// console.log(temp_str);
						this.list_upd = o;
						this.show_upd = true;
					}
				}
			},
			init_login: function() {
				this.record='';
				this.userno='';
				this.pwd='';

				this.$post(
					api.http_method,
					Method_EasySelect('sys_login_init')
				).then(res => {
					res = JSON.parse(res);
					// console.log('1',res);
					if (res.data.status == 1) {
						// console.log(res);
						this.record=res.data.data[0].beian;
						this.userno=res.data.data[0].tuser;
						this.pwd=res.data.data[0].tpass;
						
					} else {
						this.$message({
							message: '没有待完成业务单号,原因:' + res.data.msg,
							type: 'warning'
						});
					}

				});

			}


		}
	};
</script>
<style scoped>
	.my_body {
		text-align: right;
	}

	.my-page-first {
		display: flex;
		justify-content: space-around;
		flex-direction: row;
		align-items: center;
	}

	.my-update {
		display: inline-flex;
		width: 30%;
		text-align: left;
		background: white;
		border-radius: 5px;
		padding: 8px;
		align-items: center;
		max-height: 600px;
		max-width: 480px;
	}

	.s-body {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.s-name {
		font-size: 18px;
		font-weight: bold;
	}

	.s-desc {
		font-size: 16px;
		margin-top: 8px;
		margin-bottom: 6px;
	}

	.s-date {
		font-size: 14px;
		text-align: right;
		color: #7e7e7e;
	}

	.s-more {
		font-size: 13px;
		color: #0000ff;
		margin-left: 6px;
	}

	.my-login {
		display: inline-block;
		margin-top: 10%;
		margin-right: 5%;
		padding: 40px;
		min-width: 400px;
		width: 30%;
		background: rgb(6, 6, 10, 0.75);
		text-align: center;
		border-radius: 50px;
	}

	.my-login>div {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.dl .shuru {
		width: 220px;
		height: 24px;
		border: 1px solid #cccccc;
		outline: none;
		padding-left: 10px;
		background: #fff;
	}

	.my-login>div>input {
		width: 80px;
		height: 28px;
		border: none;
		outline: none;
		background: #fff;
	}

	.my-login>div>h1 {
		color: #fff;
		margin-bottom: 30px;
	}

	.el-loading-mask {
		border-radius: 50px;
	}
</style>